/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSavedArticles from 'sites/allas/components/standalone/SavedArticles';

export const DynamicStandaloneSavedArticles = StandaloneSavedArticles;
export type DynamicStandaloneSavedArticlesProps = PropsFromComponent<typeof StandaloneSavedArticles>;

export const DynamicStandaloneSavedArticlesWith = (extras: DynamicStandaloneExtras): typeof StandaloneSavedArticles => {
    return function DynamicStandaloneSavedArticles(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SavedArticles');
        return <StandaloneSavedArticles {...mergeProps({ options: { theme } }, props)} />;
    }
}